import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="border-y border-electric/30 bg-industrial py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-173" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-174" data-mp="j7ov5x0z344l">
        <SectionHeading id="summary-title" data-id="element-175" data-mp="j8zy5umlg7un">Everything Included:</SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-electric/50 bg-navy shadow-glow sm:grid-cols-2" data-id="element-176" data-mp="1guf8bx11e8ib">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-electric/15 p-4 sm:odd:border-r" data-id="element-177" data-mp="16whn7ieh4rtx">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-electric" data-id="element-178" data-mp="12vxoiae95g5o">
                <CheckIcon className="h-3.5 w-3.5 text-navy" aria-hidden="true" data-id="element-179" data-mp="3ro1oje63kdst" />
              </span>
              <b className="text-sm text-silver" data-id="element-180" data-mp="3nklqcdedq5e0">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}